export const journalTranslations = {
  ar: {
    title: 'القيود',
    addNew: 'إضافة قيد جديد',
    search: 'بحث...',
    serial: 'الرقم المسلسل',
    date: 'التاريخ',
    operationType: 'نوع القيد',
    description: 'الوصف',
    amount: 'المبلغ',
    status: 'الحالة',
    actions: 'الإجراءات',
    view: 'عرض',
    copy: 'نسخ',
    print: 'طباعة',
    edit: 'تعديل',
    delete: 'حذف',
    printList: 'طباعة القائمة',
    noEntries: 'لا توجد قيود',
    loading: 'جاري تحميل القيود...',
    error: 'فشل تحميل القيود',
    draft: 'مسودة',
    posted: 'معتمد',
    cancelled: 'ملغي',
    copySuccess: 'تم نسخ القيد بنجاح',
    deleteSuccess: 'تم حذف القيد بنجاح',
    deleteError: 'فشل حذف القيد',
    forceDeleteTitle: 'حذف القيد مع تحمل المسؤولية',
    forceDeleteMessage: 'سيتم حذف هذا القيد من المحاسبة حتى لو كان ناتجاً عن فاتورة بيع أو أي مستند آخر. المستند الأصلي لن يُحذف، لكن القيد سيختفي من التقارير والكشوف.',
    forceDeleteConfirm: 'حذف القيد',
    forceDeleteAcknowledge: 'أوافق على تحمل مسؤولية حذف هذا القيد، حتى لو كان مرتبطاً بفاتورة أو مستند آخر',
    reverse: 'عكس',
    reverseConfirm: 'هل أنت متأكد من عكس هذا القيد؟ سيتم إنشاء قيد عكسي تلقائياً ووضع علامة "ملغى" على القيد الأصلي.',
    reverseSuccess: 'تم عكس القيد بنجاح',
    reverseError: 'فشل عكس القيد',
    unpost: 'إلغاء الترحيل',
    unpostConfirm: 'هل أنت متأكد من إلغاء ترحيل هذا القيد؟ سيعود القيد إلى مسودة ويمكن تعديله ثم ترحيله مرة أخرى.',
    unpostSuccess: 'تم إلغاء ترحيل القيد بنجاح',
    unpostError: 'فشل إلغاء ترحيل القيد',
    transferOperations: 'نقل عمليات حساب',
    fiscalYearClosed: 'السنة المالية مغلقة',
    fiscalYearClosedMessage: 'السنة المالية "{name}" مغلقة. يمكنك فقط عرض القيود.',
    recurringEntries: 'القيود الدورية',
    generateSuccess: 'تم إنشاء القيد بنجاح',
    generateError: 'فشل إنشاء القيد',
    generateAllSuccess: 'تم إنشاء جميع القيود بنجاح',
    generateAllError: 'فشل إنشاء بعض القيود',
    generateAll: 'إنشاء الكل',
    daily: 'يومي',
    weekly: 'أسبوعي',
    monthly: 'شهري',
    yearly: 'سنوي',
    recurrenceType: 'نوع التكرار',
    startDate: 'تاريخ البدء',
    nextGeneration: 'تاريخ الإنشاء التالي',
    // رسائل تحذيرية للحسابات
    parentAccountWarning: '⚠️ لا يمكن إنشاء قيد على حساب رئيسي (أب)',
    parentAccountError: 'لا يمكن ترحيل قيود إلى الحساب الرئيسي. فقط الحسابات الفرعية (الورقية) يمكن أن يكون لها حركات.',
    accountNotFound: 'الحساب غير موجود',
    accountInactive: 'الحساب غير نشط',
    invalidAccounts: 'يوجد خطأ في بعض الحسابات المختارة',
    accountValidationTitle: 'خطأ في التحقق من الحسابات',
    leafAccountsOnly: 'يُسمح فقط بالحسابات الفرعية (الورقية) في القيود المحاسبية',
    accountHasChildren: 'هذا الحساب له حسابات فرعية، لا يمكن إضافة قيود عليه مباشرة',
    selectOperationType: 'اختر نوع القيد',
    noOperationTypes: 'لا توجد أنواع قيود',
    noOperationTypesMatch: 'لا توجد أنواع مطابقة للبحث',
  },
  en: {
    title: 'Journal Entries',
    addNew: 'Add New Entry',
    search: 'Search...',
    serial: 'Serial',
    date: 'Date',
    operationType: 'Entry Type',
    description: 'Description',
    amount: 'Amount',
    status: 'Status',
    actions: 'Actions',
    view: 'View',
    copy: 'Copy',
    print: 'Print',
    edit: 'Edit',
    delete: 'Delete',
    printList: 'Print List',
    noEntries: 'No journal entries',
    loading: 'Loading journal entries...',
    error: 'Failed to load journal entries',
    draft: 'Draft',
    posted: 'Posted',
    cancelled: 'Cancelled',
    copySuccess: 'Journal entry copied successfully',
    deleteSuccess: 'Journal entry deleted successfully',
    deleteError: 'Failed to delete journal entry',
    forceDeleteTitle: 'Delete journal and accept responsibility',
    forceDeleteMessage: 'This journal will be removed from accounting even if it came from a sales invoice or any other document. The source document is kept, but the journal will disappear from reports and statements.',
    forceDeleteConfirm: 'Delete journal',
    forceDeleteAcknowledge: 'I accept responsibility for deleting this journal entry, even if it is linked to an invoice or another document',
    reverse: 'Reverse',
    reverseConfirm: 'Are you sure you want to reverse this journal entry? A reversal entry will be created automatically and the original entry will be marked as cancelled.',
    reverseSuccess: 'Journal entry reversed successfully',
    reverseError: 'Failed to reverse journal entry',
    unpost: 'Unpost',
    unpostConfirm: 'Are you sure you want to unpost this journal entry? It will return to draft so you can edit it and post it again.',
    unpostSuccess: 'Journal entry unposted successfully',
    unpostError: 'Failed to unpost journal entry',
    transferOperations: 'Transfer Account Operations',
    fiscalYearClosed: 'Fiscal Year Closed',
    fiscalYearClosedMessage: 'Fiscal year "{name}" is closed. You can only view journal entries.',
    recurringEntries: 'Recurring Journal Entries',
    generateSuccess: 'Entry generated successfully',
    generateError: 'Failed to generate entry',
    generateAllSuccess: 'All entries generated successfully',
    generateAllError: 'Failed to generate some entries',
    generateAll: 'Generate All',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    recurrenceType: 'Recurrence Type',
    startDate: 'Start Date',
    nextGeneration: 'Next Generation Date',
    // Account validation messages
    parentAccountWarning: '⚠️ Cannot create entry on parent account',
    parentAccountError: 'Cannot post entries to parent account. Only leaf accounts can have transactions.',
    accountNotFound: 'Account not found',
    accountInactive: 'Account is inactive',
    invalidAccounts: 'Some selected accounts have errors',
    accountValidationTitle: 'Account Validation Error',
    leafAccountsOnly: 'Only leaf accounts are allowed in journal entries',
    accountHasChildren: 'This account has sub-accounts, cannot post entries directly',
    selectOperationType: 'Select Operation Type',
    noOperationTypes: 'No operation types found',
    noOperationTypesMatch: 'No types match your search',
  },
  fr: {
    title: 'Écritures comptables',
    addNew: 'Ajouter une nouvelle écriture',
    search: 'Rechercher...',
    serial: 'Série',
    date: 'Date',
    operationType: 'Type d\'écriture',
    description: 'Description',
    amount: 'Montant',
    status: 'Statut',
    actions: 'Actions',
    view: 'Voir',
    copy: 'Copier',
    print: 'Imprimer',
    edit: 'Modifier',
    delete: 'Supprimer',
    printList: 'Imprimer la liste',
    noEntries: 'Aucune écriture comptable',
    loading: 'Chargement des écritures comptables...',
    error: 'Échec du chargement des écritures comptables',
    draft: 'Brouillon',
    posted: 'Comptabilisé',
    cancelled: 'Annulé',
    copySuccess: 'Écriture comptable copiée avec succès',
    deleteSuccess: 'Écriture comptable supprimée avec succès',
    deleteError: 'Échec de la suppression de l\'écriture comptable',
    forceDeleteTitle: 'Supprimer l\'écriture et accepter la responsabilité',
    forceDeleteMessage: 'Cette écriture sera retirée de la comptabilité même si elle provient d\'une facture de vente ou d\'un autre document. Le document source est conservé, mais l\'écriture disparaîtra des rapports et des extraits.',
    forceDeleteConfirm: 'Supprimer l\'écriture',
    forceDeleteAcknowledge: 'J\'accepte la responsabilité de supprimer cette écriture, même si elle est liée à une facture ou à un autre document',
    reverse: 'Inverser',
    reverseConfirm: 'Êtes-vous sûr de vouloir inverser cette écriture comptable? Une écriture d\'inversion sera créée automatiquement et l\'écriture originale sera marquée comme annulée.',
    reverseSuccess: 'Écriture comptable inversée avec succès',
    reverseError: 'Échec de l\'inversion de l\'écriture comptable',
    unpost: 'Décomptabiliser',
    unpostConfirm: 'Êtes-vous sûr de vouloir décomptabiliser cette écriture ? Elle redeviendra un brouillon afin que vous puissiez la modifier puis la comptabiliser à nouveau.',
    unpostSuccess: 'Écriture décomptabilisée avec succès',
    unpostError: 'Échec de la décomptabilisation de l\'écriture',
    transferOperations: 'Transfert des opérations de compte',
    fiscalYearClosed: 'Exercice fiscal fermé',
    fiscalYearClosedMessage: 'L\'exercice fiscal "{name}" est fermé. Vous ne pouvez que consulter les écritures comptables.',
    recurringEntries: 'Écritures comptables récurrentes',
    generateSuccess: 'Écriture générée avec succès',
    generateError: 'Échec de la génération de l\'écriture',
    generateAllSuccess: 'Toutes les écritures générées avec succès',
    generateAllError: 'Échec de la génération de certaines écritures',
    generateAll: 'Générer tout',
    daily: 'Quotidien',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    recurrenceType: 'Type de récurrence',
    startDate: 'Date de début',
    nextGeneration: 'Date de génération suivante',
    // Messages de validation des comptes
    parentAccountWarning: '⚠️ Impossible de créer une écriture sur un compte parent',
    parentAccountError: 'Impossible de passer des écritures sur un compte parent. Seuls les comptes feuilles peuvent avoir des transactions.',
    accountNotFound: 'Compte non trouvé',
    accountInactive: 'Le compte est inactif',
    invalidAccounts: 'Certains comptes sélectionnés contiennent des erreurs',
    accountValidationTitle: 'Erreur de validation du compte',
    leafAccountsOnly: 'Seuls les comptes feuilles sont autorisés dans les écritures comptables',
    accountHasChildren: 'Ce compte a des sous-comptes, impossible de passer des écritures directement',
  },
}

